/**
 * Mirror of `MtlsRegistry.isOriginMatch`: configured origins missing a scheme
 * are coerced to https:// before being normalized through URL.origin so that
 * `api.example.com` and `https://api.example.com` collapse to the same key.
 */
export function normalizeOriginKey(
  origin: string | undefined,
): string | undefined {
  if (!origin) return undefined;
  const trimmed = origin.trim();

  if (!trimmed) return undefined;

  try {
    const candidate = /^https?:\/\//i.test(trimmed)
      ? trimmed
      : `https://${trimmed}`;

    return new URL(candidate).origin.toLowerCase();
  } catch {
    return trimmed.toLowerCase();
  }
}
